<script>
  import {Line} from 'vue-chartjs'

  export default {
    props: {
      chartdata: {
        type: Object,
        default: null
      },
      options: {
        type: Object,
        default: null
      }
    },
    extends: Line,
    name: "LineChart",
    mounted() {
      this.doRender()
    },
    methods:{
      doRender: function() {
        this.renderChart(this.chartdata, this.options)
      }
    },
    watch: {
      chartdata: {
        deep: true,
        handler()
        {
          this.doRender()
        }
      }
    }
  }

</script>

<style lang="scss" scoped>
 @import '~vuetify/src/styles/settings/_variables';
  canvas {
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      width: 100% !important;

    }
  }
</style>



// WEBPACK FOOTER //
// src/Charts/LineChart.vue